export default async(modul_id,actualRoom) =>
{
    console.log('%c 🍪 Cookie Module Loaded! ', 'background: #222; color: #bada55');

}
